import { BareButton } from '@calendly/ui/components/bare-button';
import { IconCircleCheck } from '@calendly/ui/components/glyphs/IconCircleCheck';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { colorIconSuccess } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
const centerContainerCss = "c15bfg9f";
const CenterContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(centerContainerCss, props.className)} />;
});
export const ConfirmationIcon = () => <CenterContainer>
    <UiIcon icon={IconCircleCheck} size="large" spacingBottom="16" color={colorIconSuccess} />
  </CenterContainer>;
const subtextCss = "svsf5vi";
export const Subtext = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(subtextCss, props.className)} />;
});
const reasonButtonCss = "r8x6h3x";
export const ReasonButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(reasonButtonCss, props.className)} />);
const headerInnerCss = "h1n1sonf";
export const HeaderInner = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerInnerCss, props.className)} />;
});
const backButtonCss = "b10vfulk";
export const BackButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(backButtonCss, props.className)} />);
const labelGrayCss = "l1od0nog";
const labelCss = "l1b5gzv5";
export const Label = forwardRef((props, ref) => {
  const {
    gray,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, {
    [labelGrayCss]: gray
  }, props.className)} />;
});
const reportReasonCss = "r1mw6mx8";
export const ReportReason = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(reportReasonCss, props.className)} />;
});
const containerCss = "c10pn1r5";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const messageCss = "m65g91o";
export const Message = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(messageCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");